import React from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';

interface TagProps {
  text: string;
  color: string;
  icon?: React.JSX.Element;
  className?: string;
  textColor?: string;
}

export const Tag = ({ text, color, icon, className, textColor }: TagProps) => (
  <div
    className={clsx(styles.tag, className)}
    style={{ backgroundColor: color }}
  >
    {icon}
    <span style={{ color: textColor }}>{text}</span>
  </div>
);
